import React, { useState } from 'react';
import useReactRouter from 'use-react-router';
import userStore from 'store/user';
import { observer } from 'mobx-react-lite';
import UpdatePassword from 'components/public-components/update-password';
import { IConfirmContract } from '@/interfaces/user';

const FirstUpdatePassword = observer(() => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { history } = useReactRouter();

  const changePassword = async (password: string) => {
    setIsLoading(true);
    try {
      const formData = {
        newPassword: password,
      };
      await userStore.confirmContract(formData as IConfirmContract);
      const userProfile = Object.assign({}, userStore.userProfile, { isFirstLogin: false });
      userStore.setUserProfile(userProfile);
      history.push('/main/dashboard');
    } catch (e) {
      setIsLoading(false);
    }
  };

  return <UpdatePassword changePassword={changePassword} isLoading={isLoading} />;
});

export default FirstUpdatePassword;
